import type { SVGProps } from "react";
const SvgPresentationOnline = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeWidth={1.5}
      d="M5.409 17.118c-.359-1.516-.538-2.274-.303-2.858.146-.363.396-.676.72-.9C6.346 13 7.13 13 8.702 13h6.597c1.57 0 2.355 0 2.875.36.324.224.574.537.72.9.235.584.056 1.342-.303 2.858-.353 1.494-.53 2.24-.97 2.777a3 3 0 0 1-1.02.802c-.628.303-1.402.303-2.949.303h-3.304c-1.547 0-2.32 0-2.948-.303a3 3 0 0 1-1.02-.802c-.442-.537-.618-1.283-.971-2.777Z"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth={1.5}
      d="M3 21h18M11 16h2"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M8 11c1.838-2.595 6.119-2.737 8 0"
    />
    <path
      stroke="currentColor"
      strokeWidth={1.5}
      d="M14 5a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z"
    />
  </svg>
);
export default SvgPresentationOnline;
